/*global _ */
import {Vue} from '~/addiesaas'
import spaces from '../../../../../../spaces.json'

export {spaces}
const ad = window.addiesaas || (window.addiesaas = {})
export const RE = ad
const adConfig = ad.config || {}
export const CONFIG = adConfig
export const env = adConfig.env
export const jsDebug = adConfig.jsDebug
export const jsDebugLog = adConfig.jsDebugLog
export const isLocalDev = /local|development/i.test(env)
export const isEnv = (q) => {
  return _.castArray(q).includes(env)
}

export const routes = _.keyBy(ad['routes'] || [], 'name')

import {root as rootSetting} from './settings'

const firstCondition = (exp) => {
  let found = _.castArray(exp).find(i => !_.isNil(i))
  return !!({'false': false, 'true': true}[found] || found)
}
export const debug = firstCondition([rootSetting('debug'), rootSetting('global.debug'), isLocalDev])

export const debugLog = (() => {
  const needsLog = firstCondition([jsDebugLog, debug])
  const unfn = () => {
  }
  if (needsLog) {
    // eslint-disable-next-line no-console
    return console && console.log || unfn
  }
  return unfn
})()

export const config = Object.assign({}, {
  debug,
  env,
  isEnv,
  routes,
  RE,
  CONFIG,
  spaces
})

Vue.prototype.$$debug = debug
Vue.prototype.$$env = env
window.debugLog = Vue.prototype.$$debugLog = debugLog

const isDevTools = firstCondition([jsDebug, debug])
if (isDevTools) {
  debugLog('Enable Vue Dev Tools')
  Vue.config.devtools = true
}

export default config

